import React from 'react';

const SelfInspectDivider = ({ spacing = 10, className, style = {} }) => {
  return (
    <div
      //
      style={{
        height: 2,
        width: '100%',
        backgroundColor: '#00000010',
        margin: `${spacing}px 0px`,
        ...style,
      }}
      className={className}
    />
  );
};

export default SelfInspectDivider;
